export default __webpack_public_path__ + "static/media/Rectangle-1655-Yono.e179aabe.png";